<footer class="footer">
    <!-- <br><a href="https://gamebit.company">Gamebit</a> -->
    <p>&copy; 2016-2018 <a href="https://gamebit.company">Gamebit LLC</a> | Term of Use </p>
</footer>



// WEBPACK FOOTER //
// ./src/app/ui/footer-nav/footer-nav.component.html